exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".option-right {\n  padding-right: 16px;\n  margin-top: 32px;\n  margin-bottom: 12px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/repository/repository.component.css
// module id = 827
// module chunks = 0